import { render, staticRenderFns } from "./Hello_Boy.vue?vue&type=template&id=26a08765&scoped=true"
import script from "./Hello_Boy.vue?vue&type=script&lang=js"
export * from "./Hello_Boy.vue?vue&type=script&lang=js"
import style0 from "./Hello_Boy.vue?vue&type=style&index=0&id=26a08765&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a08765",
  null
  
)

export default component.exports